import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';

export const buildMarqueeBasicTextSection = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const fieldUpdate = {
    title: 'Marquee Basic Text',
    enableAnchor: false,
    padding: {
      top: true,
      bottom: true,
    },
    background: '#ffffff',
    color: '#000000',
    'list-item':
      suggestionFields?.content?.marquee_items?.map(item => ({
        text: item.text,
      })) || [],
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionMarqueeBasicText(newSection.html, fieldUpdate),
  };
};
